import React, {Component} from 'react';

export const ShipContext = React.createContext();

export class ShipContextProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeAreaId: '',
            activeSubareaId: '',
            shipType: '',
            setActiveSubareaId: (activeSubareaId) => {
                this.setState({activeSubareaId});
            },
            resetActiveAreas: () => {
                this.setState({
                    activeAreaId: '',
                    activeAreaOnImageId: '',
                    activeSubareaId: ''
                })
            },
            setActiveAreaId: (activeAreaId) => {
               this.setState({activeAreaId});
            },
            setShipType: (shipType) => {
                this.setState({shipType})
            }
        }
    }

    render() {
        return (
            <ShipContext.Provider value={this.state}>
                {this.props.children}
            </ShipContext.Provider>
        )
    }
}